import apiDocumentationMd from '../../../assets/legal-documents/api-documentation.md?raw';

export type ApiDocumentationConfig = {
  slug: string;
  title: string;
  fileName: string;
  content: string;
  introduction: string;
  lastUpdated: string;
  description?: string;
};

const extractIntroduction = (markdown: string): string => {
  const lines = markdown.split('\n');
  const introLines: string[] = [];
  let foundTitle = false;
  let foundFirstH2 = false;

  for (const line of lines) {
    if (line.startsWith('# ')) {
      foundTitle = true;
      continue;
    }

    if (line.startsWith('## ') && foundTitle) {
      foundFirstH2 = true;
      break;
    }

    if (foundTitle && !foundFirstH2) {
      if (!line.includes('**Last Updated:**') && line.trim()) {
        introLines.push(line);
      }
    }
  }

  return introLines.join('\n').trim();
};

const removeIntroduction = (markdown: string): string => {
  const lines = markdown.split('\n');
  const contentLines: string[] = [];
  let foundFirstH2 = false;

  for (const line of lines) {
    if (line.startsWith('## ')) {
      foundFirstH2 = true;
    }

    if (foundFirstH2) {
      contentLines.push(line);
    }
  }

  return contentLines.join('\n').trim();
};

export const API_DOCUMENTATION: ApiDocumentationConfig = {
  slug: 'api-documentation',
  title: 'API Documentation',
  fileName: 'api-documentation.md',
  content: removeIntroduction(apiDocumentationMd),
  introduction: extractIntroduction(apiDocumentationMd),
  lastUpdated: '2025-12-19',
  description: 'Comprehensive guide for integrating Bhutan Payments API',
};

export const getApiDocumentation = (): ApiDocumentationConfig => {
  return API_DOCUMENTATION;
};
